import styled from "styled-components";
import { ElementGroup, Title } from "styles/components";
import { PopupType } from "../PopupType";
import { useAbsPopupButton, usePopupData } from "commons/popup/store/absPopupHook";
import Button from "components/ui/Button";
import { ButtonType } from "components/ComponentsType";
import AbsPopup from "commons/popup/display/AbsPopup";
import { ButtonState } from "commons/popup/store/absPopupVo";
import UiInputText from "commons/components/ui/UiInputText";
import { useApplyRatioChannel } from "./calculateRatioHook";
import { UiCheckBox } from "commons/components/CheckBox";
import type { IContentsChanneGridDetail } from "pages/calculate/store/CalculateVo";
import { useGridCheckBoxValue } from "commons/ui/useGrid";

const TitleDiv = styled.div`
  width: 100%;
  padding: 10px 0;
  height: 28px;
  h3 {
    margin-bottom: 0;
    font-size: 16px;
    text-align: center;
  }
`;

const ContentDiv = styled.div`
  width: 100%;
  position: relative;
  input {
    width: 100%;
    text-align: center;
    border-radius: 6px;
    &::after {
      content: "%";
      width: 10px;
      display: block;
    }
  }
  .channel-container {
    width: 100%;
    border: 1px solid var(--border-primary);
    font-size: 0.93rem;
    margin-top: 5px;
    > p {
      padding: 3px 0;
      text-align: center;
      font-weight: 500;
      color: var(--font-red);
      background-color: #ececec;
      font-size: 0.86rem;
    }
    div {
      padding: 6px 10px;
      border: 1px solid #dfdfdf;
      height: auto;
      max-height: 500px;
      overflow-y: scroll;
      text-align: left;
      label {
        &:first-child {
          border-bottom: 1px solid var(--border-normal);
          padding-bottom: 10px;
        }
        padding: 8px 8px;
        font-size: 1rem;
        white-space: break-spaces;
        overflow-x: hidden;
        text-overflow: ellipsis;
        text-align: left;
      }
    }
  }
`;
const FooterStyle = styled(ElementGroup.Row)`
  padding: 0px 18px 10px 18px;
`;

export function RatioButtonGroup() {
  // const { popupDo } = usePopupData<ICalculateRatioPoppupData>(PopupType.CALCULATE_RATIO_POPUP);
  const { close } = useAbsPopupButton(PopupType.CALCULATE_RATIO_POPUP);
  const { apply } = useApplyRatioChannel();
  return (
    <FooterStyle flexContent="between">
      <Button text="취소" thin btnSize={"xsm"} btnType={ButtonType.BORDER} onClick={close.bind(null, ButtonState.NO)} />
      <Button text="요율 일괄 적용" thin btnSize={"xsm"} color={"secondary"} onClick={apply} />
    </FooterStyle>
  );
}

function PopupHeader() {
  return (
    <TitleDiv>
      <Title weight="regular">선택 요율 수정</Title>
    </TitleDiv>
  );
}

export default function CalculateRatioPopup(): JSX.Element {
  const { popupDo } = usePopupData<IContentsChanneGridDetail[]>(PopupType.CALCULATE_RATIO_POPUP);
  // const { setTotalGridValue } = useGridCheckBoxValue();
  // const gridAllCheck = (value?: boolean) => {
  //   setTotalGridValue(value!);
  // };
  return (
    <AbsPopup type={PopupType.CALCULATE_RATIO_POPUP} borderShape={4} header={<PopupHeader />}>
      <ContentDiv>
        <UiInputText id="popup_ratio_input" type="number" placeholder="요율 입력" />

        <div className="channel-container">
          <p>요율 변경시 해당 월부터 적용됩니다</p>
          <div>
            {/* {popupDo.data &&
              popupDo.data.checkList.map((i, idx) => {
                const name = i.substring(i.indexOf("_") + 1, i.length);
                return i !== "isAll" && <p key={idx}>{name}</p>;
              })} */}

            {/* <UiCheckBox id="isAll" name="gridAllCheckbox" change={gridAllCheck} text={"전체선택"} /> */}
            <UiCheckBox id="isAll" name="gridAllCheckbox" text={"전체선택"} />
            {popupDo.data &&
              popupDo.data.map((i, idx) => {
                return (
                  <UiCheckBox
                    key={idx}
                    id={`ratio_${i.code}`}
                    name="gridAllCheckbox"
                    // change={gridAllCheck}
                    text={i.name}
                  />
                );
              })}
          </div>
        </div>
      </ContentDiv>
    </AbsPopup>
  );
}
